module.exports = __webpack_public_path__ + "img/BG.0b45554a.jpg";